import React, { useEffect } from "react"
import { Box, Skeleton, Typography } from "@mui/material"
import { useLocation, useSearchParams } from "react-router-dom"

import { ONE_WAY_ROUTES } from "@constants"
import { AppOfficesBlock } from "@components"
import { offices, reports, searchID } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import ReportsAutocomplete from "Pages/@PageWrapper/Actions/Reports"
import { resetCustomFilters } from "Pages/AnalyzersV2/@signals"
import { useSearchDate } from "Pages/AnalyzersV2/@hooks"
import OneWayContent from "Pages/AnalyzersV2/OneWay/Content"
import OneWayFilters from "Pages/AnalyzersV2/OneWay/Filters"
import { resetOneWayData } from "Pages/AnalyzersV2/OneWay/@signals"


export default function OneWayAnalyzer() {

	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()

	useEffect(() => {
		resetCustomFilters()
		resetOneWayData()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	useEffect(() => resetOneWayData, [])

	return <PageWrapper
		head={`DS Rentacar | ${ONE_WAY_ROUTES.ANALYZER_TITLE}`}
		title={ONE_WAY_ROUTES.TITLE}
		subtitle={ONE_WAY_ROUTES.ANALYZER_TITLE}
		isEmpty={false}
		filters={<OneWayFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
			{!searchID.value && <Box sx={{ minWidth: 300, mr: 2 }}>
				<ReportsAutocomplete filters={{ onlyOneWay: true }}/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rectangular' height={30} />
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 2, color: 'secondary.main' }}>
						<AppOfficesBlock sx={{ color: 'black' }} {...office} /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
		</Box>}
	>
		<OneWayContent/>
	</PageWrapper>
}